export default __webpack_public_path__ + "static/media/ph_1.9dcedb18.jpg";